export default "__VITE_ASSET__wihXYSNQ__"